import React, { useState, useEffect } from "react";

// Import Highcharts
import Highcharts from "highcharts";
import HCMore from "highcharts/highcharts-more";
import solidGauge from "highcharts/modules/solid-gauge";
import HighchartsReact from "highcharts-react-official";

HCMore(Highcharts);
solidGauge(Highcharts);

const PerformanceColumnSmall = (props) => {
  // console.log(props?.data);
  var customIcon = [
    "nicon-education-new",
    "nicon-skills",
    "nicon-awards",
    "nicon-career",
    "nicon-goals",
  ];
  const [options, setOptions] = useState({});

  useEffect(() => {
    if(props.data !== undefined )
    setOptions({
      chart: {
        type: "column",
        marginTop: 0,
        height:'200',
        backgroundColor:'transparent',
       
      },
      plotOptions: {
        column: {
          colorByPoint: true,
          groupPadding: 0,
          pointPadding: 0,
          borderWidth: 0,
        },
      },
      colors: ["#E54126", "#F49E1D", "#29B3AF", "#2F9CCA"],
      title: {
        text: "",
      },
      xAxis: {
        gridLineColor: "#bebebc",
        gridLineWidth: 1,
        categories: [
          " Experience",
          "Qualifications",
          "Training",
          "Systems",
        ],
        labels: {
          enabled: false,
          rotation: 0,
          align: "center",
          useHTML: true,
          formatter: function () {
            return (
              '<div class="custom-label" style="margin-top:15px;color:#666666;font-weight:600;font-size:14px;"><div class="label-value">' +
              this.value +
              "</div></div>"
            );
          },
          style: {
            fontSize: "13px",
            fontFamily: "Verdana, sans-serif",
          },
        },
      },
      yAxis: {
        min: 0,
        gridLineWidth: 0,
        title: {
          enabled: false,
        },
        labels: {
          enabled: false,
        },
      },
      legend: {
        enabled: false,
      },
      credits: {
        enabled: false,
      },
      tooltip: {
        formatter: function () {
          return "<b>" + this.x + "</b><br/>";
        },
      },
      series: [
        {
          name: "Population",
          data: props?.data,
          dataLabels: {
            enabled: true,
            rotation: 0,
            color: "#FFFFFF",
            align: "top",
            y: -80,
            useHTML: true,
            formatter: function () {
              // console.log(this);
              return (
                '<div class="top-label"><span style="color:' +
                this.color +
                ';font-size:14px;">' +
                this.y +
                " %</span></div>"
              );
            },
          },
        },
      
      ],
    });
  }, [props]);

  return props.data ?  (
    <HighchartsReact
      highcharts={Highcharts}
      options={options}
      containerProps={{ className: "equal-height-graph" }}
    />
  ) : null ;
};

export default PerformanceColumnSmall;
